import React from 'react';
import { useChannelIOApi } from 'react-channel-plugin';
import "./style.scss";

const SnsPackage = ({mobile}) => {
    const { showMessenger} = useChannelIOApi();
    return mobile ? (
        <div className="mobile-bottom-cn">
            <div className="chatting-cn" onClick={showMessenger}>
                <img className="chatting-icon" src="/img/icons/chatting-bottom.png" />
                <p>실시간 채팅문의</p>
            </div>
            <div 
                className="blog-cn"
                onClick={()=>{
                    window.open(
                        "https://blog.naver.com/3652275",
                        "_blank"
                        );
                    }}
            >
                <img className="blog-icon" src="/img/icons/blog-bottom.png" />
                <p>블로그 바로가기</p>
            </div>
        </div>
    ) : (
        <div className={mobile ? "m-sns-cn" : "pc-sns-cn"}>
            <img 
                onClick={()=>{
                    window.open(
                        "https://pf.kakao.com/_NDapV",
                        "_blank"
                    );
                }}
                className="kakaotalk" 
                src="/img/kakaotalk@2x.png" 
            />
            <img 
                onClick={()=>{
                    window.open(
                        "https://blog.naver.com/3652275",
                        "_blank"
                        );
                    }}
                className="blog" src="/img/blog@2x.png" 
            />
            <img 
                onClick={()=>{
                    window.open(
                        "https://www.instagram.com/baren_jung_plant_dental_clinic/",
                        "_blank"
                    );
                }}
                className="insta" 
                src="/img/insta@2x.png" 
            />
            <img 
                onClick={()=>{
                    window.open(
                        "https://ko-kr.facebook.com/bj2275/",
                        "_blank"
                    );
                }}
                className="facebook" 
                src="/img/facebook@2x.png" 
            />
        </div>
    );
};

export default SnsPackage;